<template>
    <main-sidebar :name="name" :title="$t('purchase_orders') | capitalize" size="large">
        <div>
            <vs-row class="mt-2 px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    {{ $t('client') | capitalize }}
                </vs-col>
            </vs-row>
            <vs-row class="px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    <v-select :clearable="false" :options="clients" class="w-full" :reduce="(item) => item.id"
                        label="name" v-model="form.client" />
                </vs-col>
            </vs-row>
            <vs-row class="mt-2 px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    {{ $t('vendor') | capitalize }}
                </vs-col>
            </vs-row>
            <vs-row class="px-4">
                <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                    <v-select label="name" :filterable="false" :options="vendors" @search="onSearchVendors"
                        v-model="form.vendor" class="w-full"></v-select>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                    <add-vendor @success="newVendor" class="px-2" />
                </vs-col>
            </vs-row>

            <vs-row class="mt-2">
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            {{ $t('departament') | capitalize }}
                        </vs-col>
                    </vs-row>
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <v-select :clearable="false" :options="departaments" class="w-full"
                                :reduce="(item) => item.id" label="name" v-model="form.departament" />
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            {{ $t('category') | capitalize }}
                        </vs-col>
                    </vs-row>
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <v-select :clearable="false" :options="categories" class="w-full"
                                :reduce="(item) => item.id" label="name" v-model="form.category" />
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>


            <vs-row class="mt-2 px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    {{ $t('account_number') | capitalize }}
                </vs-col>
            </vs-row>
            <vs-row class="px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    <vs-input type="text" class="w-full" v-model="form.accountNumber" name="account"
                        v-validate="{ length: 12 }" />
                </vs-col>
                <vs-col vs-w="12">
                    <span class="text-danger text-sm" v-show="errors.has('account')">{{
                        errors.first('account') }}
                    </span>
                </vs-col>
            </vs-row>
            <vs-row class="mt-2 px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    {{ $t('folio') | capitalize }}
                </vs-col>
            </vs-row>
            <vs-row class="px-4">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    <vs-input type="text" class="w-full" v-model="form.folio" />
                </vs-col>
            </vs-row>

            <vs-row class="mt-2">
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pr-1">
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            IVA
                        </vs-col>
                    </vs-row>
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <v-select :clearable="false" :options="iva" class="w-full" :reduce="(item) => item.value"
                                label="label" v-model="form.iva" />
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pl-1">
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            {{ $t('currency') | capitalize }}
                        </vs-col>
                    </vs-row>
                    <vs-row class="px-4">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <v-select :clearable="false" :options="currencies" class="w-full"
                                :reduce="(item) => item.value" label="label" v-model="form.currency" />
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>
            <vs-row class="mt-2">
                <po-items class="w-full px-4" :data="items" @remove="remove"></po-items>
            </vs-row>
            <vs-row class="mt-2 px-4">
                <vs-col vs-xs="12" vs-sm="5" vs-lg="5">
                    <vs-input class="w-full px-1" :label="$t('description') | capitalize" v-model="item.description" />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                    <vs-input class="w-full px-1" type="number" v-mask="'###'" :label="$t('quantity') | capitalize"
                        v-model="item.quantity" />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                    <vs-input class="w-full px-1" type="number" :label="$t('unit_cost') | capitalize"
                        v-model="item.price" />
                </vs-col>

                <vs-col vs-xs="12" vs-sm="1" vs-lg="1">
                    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus" class="w-full mt-5"
                        @click="add" :disabled="disabledAdd"></vs-button>
                </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4 px-4">
                <vs-col vs-w="2" class="text-right">
                    <span class="font-bold">Subtotal:</span>
                </vs-col>
                <vs-col vs-w="2" class="text-right">
                    ${{ formatNumber(subTotal, 2) }}
                </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="flex-end" class="px-4">
                <vs-col vs-w="2" class="text-right">
                    <span class="font-bold">IVA:</span>
                </vs-col>
                <vs-col vs-w="2" class="text-right">
                    ${{ formatNumber(getIva(), 2) }}
                </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="flex-end" class="px-4">
                <vs-col vs-w="2" class="text-right">
                    <span class="font-bold">Total:</span>
                </vs-col>
                <vs-col vs-w="2" class="text-right">
                    ${{ formatNumber(subTotal + getIva(), 2) }}
                </vs-col>
            </vs-row>
        </div>
        <div slot="footer" class="mt-4">
            <vs-row vs-type="flex" vs-justify="flex-end">
                <vs-col vs-w="3" class="px-2">
                    <vs-button color="primary" type="border" class="w-full" @click="close()">
                        {{ $t('close') | capitalize }}
                    </vs-button>
                </vs-col>
                <vs-col vs-w="3" class="px-2">
                    <vs-button color="primary" type="filled" class="w-full" @click="handleSubmit()"
                        :disabled="disabledSubmit">
                        {{ $t('save') | capitalize }}
                    </vs-button>
                </vs-col>
            </vs-row>
        </div>
    </main-sidebar>
</template>

<script>
import loading from '@/mixins/Loading'
import MainSidebar from '@/views/components/MainSidebar.vue'
import AddVendor from '@/views/modules/vendors/home/components/AddVendor.vue'
import request from '../request.js'
import vSelect from 'vue-select'
import PoItems from './PoItems.vue'
import debounce from 'lodash/debounce'
export default {
    components: {
        MainSidebar,
        AddVendor,
        PoItems,
        'v-select': vSelect,
    },
    mixins: [loading],
    props: {
        name: {
            type: String,
        }
    },
    computed: {
        isSidebarActive() {
            return this.$store.state.sidebar === this.name
        },
        subTotal() {
            return this.items.length > 0 ? this.items.reduce((a, c) => Number(a) + (Number(c.price) * Number(c.quantity)), 0) : 0
        },
        disabledSubmit() {
            return this.form.client === ''
                || this.form.vendor == ''
                || this.form.category == ''
                || this.form.departament == ''
                || this.form.iva === ''
                || this.form.currency == ''
                || this.form.folio == ''
                || this.items.length == 0
                || this.errors.any()
        },
        disabledAdd() {
            return this.item.quantity === 0 || this.item.price <= 0 || this.item.description == ''
        },
        isLoading() {
            return (
                this.loading.clients ||
                this.loading.departaments ||
                this.loading.vendors ||
                this.loading.categories ||
                this.loading.submit
            )
        },
    },
    data: () => ({
        iva: [
            { value: 0, label: '0%' },
            { value: 8, label: '8%' },
            { value: 16, label: '16%' }
        ],
        currencies: [
            { value: 'MXN', label: 'MXN' },
            { value: 'USD', label: 'USD' }
        ],
        clients: [],
        vendors: [],
        departaments: [],
        categories: [],
        items: [],
        item: {
            quantity: '',
            price: '',
            description: '',
            total: ''
        },
        form: {
            iva: 0,
            currency: 'MXN',
            client: '',
            vendor: '',
            departament: '',
            category: '',
            accountNumber: '',
            folio: ''
        },
        loading: {
            clients: false,
            vendors: false,
            departaments: false,
            categories: false,
            submit: false
        }
    }),
    methods: {
        close() {
            this.$store.dispatch('toggleSidebar', '')
        },
        newVendor(vendor) {
            this.getVendors()
            this.form.vendor = {
                id: vendor.id,
                name: vendor.name,
                cateogry_contract_id: vendor.cateogry_contract_id
            }
        },
        add() {
            const item = {
                quantity: this.item.quantity,
                price: this.item.price,
                description: this.item.description,
                total: this.item.price * this.item.quantity
            }
            this.items.push(item)
            this.item = {
                quantity: '',
                price: '',
                description: ''
            }
        },
        remove(i) {
            this.items.splice(i, 1)
        },
        getIva() {
            return this.items.length > 0 ? this.subTotal * (this.form.iva / 100) : 0
        },
        getClients() {
            this.loading.clients = true
            request
                .getClients()
                .then((response) => {
                    this.clients = [...response.data]
                    this.loading.clients = false
                })
                .catch((error) => {
                    this.loading.clients = false
                    this.showValidationErrors(error)
                })
        },
        onSearchVendors(search, loading) {
            if (search.length > 3) {
                loading(true);
                this.getVendors(loading, search, this);
            }
        },
        getVendors: debounce((loading, search, vm) => {
            request
                .vendorSearch({ search: search })
                .then((res) => {
                    vm.vendors = [...res.data.vendors]
                    loading(false);
                })
                .catch((err) => {
                    vm.vendors = []
                    loading(false);
                })
        }),
        getDepartaments() {
            this.loading.departaments = true
            request
                .getDepartaments()
                .then((response) => {
                    this.departaments = [...response.data]
                    this.loading.departaments = false
                })
                .catch((error) => {
                    this.loading.departaments = false
                    this.showValidationErrors(error)
                })
        },
        getCategories() {
            this.loading.categories = true
            request
                .getCategories()
                .then((response) => {
                    this.categories = [...response.data]
                    this.loading.categories = false
                })
                .catch((error) => {
                    this.loading.categories = false
                    this.showValidationErrors(error)
                })
        },
        handleSubmit() {
            const payload = {
                client_id: this.form.client,
                vendor_id: this.form.vendor.id,
                departament_id: this.form.departament,
                category_id: this.form.category,
                account_number: this.form.accountNumber,
                folio: this.form.folio,
                currency: this.form.currency,
                iva: this.form.iva,
                subtotal: this.subTotal,
                total: this.subTotal + this.getIva(),
                details: [...this.items]
            }
            this.loading.submit = true
            request
                .store(payload)
                .then((response) => {
                    this.loading.submit = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'PO Saved'
                    });
                    this.$store.dispatch('toggleSidebar', '')
                    this.$emit('refresh')
                })
                .catch((error) => {
                    this.loading.submit = false
                    this.showValidationErrors(error)
                })

        }
    },
    watch: {
        isLoading(val) {
            if (val) {
                this.openLoading(`loading-${this.name}-sidebar`)
            } else {
                this.closeLoading(`loading-${this.name}-sidebar`)
            }
        },
        isSidebarActive(val) {
            if (val) {
                this.getClients()
                this.getCategories()
                this.getDepartaments()
                this.items = []
                this.item = {
                    quantity: '',
                    price: '',
                    description: ''
                }
                this.form = {
                    iva: 0,
                    currency: 'MXN',
                    client: '',
                    vendor: '',
                    departament: '',
                    category: '',
                    accountNumber: '',
                    folio: ''
                }
            }
        },
    },
}
</script>

<style></style>